import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component to dynamically update document title based on current route
const DocumentTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Base app name
    const baseTitle = 'PaceUp Admin';
    
    // Get current path
    const path = location.pathname;
    
    // Set specific titles based on route patterns
    if (path === '/') {
      document.title = `Dashboard | ${baseTitle}`;
    } else if (path.startsWith('/books')) {
      if (path === '/books') {
        document.title = `Books Management | ${baseTitle}`;
      } else {
        document.title = `Book Details | ${baseTitle}`;
      }
    } else if (path.startsWith('/categories')) {
      document.title = `Categories | ${baseTitle}`;
    } else if (path.startsWith('/collections')) {
      if (path === '/collections') {
        document.title = `Collections | ${baseTitle}`;
      } else {
        document.title = `Collection Details | ${baseTitle}`;
      }
    } else if (path === '/book-of-the-day') {
      document.title = `Book of the Day | ${baseTitle}`;
    } else if (path === '/users') {
      document.title = `Users Management | ${baseTitle}`;
    } else if (path === '/profile') {
      document.title = `My Profile | ${baseTitle}`;
    } else if (path === '/settings') {
      document.title = `Settings | ${baseTitle}`;
    } else if (path === '/login') {
      document.title = `Login | ${baseTitle}`;
    } else {
      // Default: use base title
      document.title = baseTitle;
    }
  }, [location]);
  
  // This component doesn't render anything
  return null;
};

export default DocumentTitle;
